/* Absolute campaign times include the store's UTC offset; no device timezone assumptions. */
(() => {
  let timer;
  function update() {
    clearTimeout(timer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-campaign-start], [data-campaign-end]').forEach(element => {
      const start = element.dataset.campaignStart ? Date.parse(element.dataset.campaignStart) : -Infinity;
      const end = element.dataset.campaignEnd ? Date.parse(element.dataset.campaignEnd) : Infinity;
      const preview = window.Shopify?.designMode && element.dataset.campaignPreview === 'true';
      element.hidden = !preview && !(now >= start && now < end);
      if (start > now) next = Math.min(next, start);
      if (end > now) next = Math.min(next, end);
    });
    if (next < Infinity) timer = setTimeout(update, Math.min(next - now + 25, 2147483647));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
})();
